import React from "react";

import theme from "components/shared/markdownEditor/editorPlugins/buttons/theme";

function Separator() {
  return <div className={theme.seperator} />;
}

export default Separator;
